import { render } from "./eventDetailCard.vue?vue&type=template&id=1e1fa595&scoped=true"
import script from "./eventDetailCard.vue?vue&type=script&lang=js"
export * from "./eventDetailCard.vue?vue&type=script&lang=js"

import "./eventDetailCard.vue?vue&type=style&index=0&id=1e1fa595&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1fa595"]])

export default __exports__